(function () {
  'use strict';

  angular.module('app').component('transportationPriceDetail', transportationPriceDetail());

  function transportationPriceDetail() {
    return {
      bindings: {
        transportationPrices: '=',
        transportation: '=',
        paxRanges: '=',
        seasonSelected: '=',
        priceListSelected: '=',
        onTransportationPricesSaved: '&',
        onTransportationPricesCanceled: '&',
      },
      controller: TransportationPriceDetailComponent,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/transportation-prices/transportation-price-detail/transportation-price-detail.component.html',
    };
  }

  TransportationPriceDetailComponent.$inject = [
    'CONFIGURATIONS',
    'UtilService',
    'TransportationPriceService',

    // Angular downgraded service
    'paxRangeService',
  ];

  function TransportationPriceDetailComponent(
    config,
    UtilService,
    TransportationPriceService,

    // Angular downgraded service
    paxRangeService
  ) {
    var vm = this;

    vm.UtilService = new UtilService(vm);

    vm.dateDisplay = config.DATE_DISPLAY;
    vm.hourDisplay = config.HOUR_DISPLAY; // Ex: 01:00 PM

    vm.selectPaxRange = selectPaxRange;

    vm.saveTransportationPrices = saveTransportationPrices;
    vm.cancel = cancel;

    vm.$onInit = function () {
      var paxRangeToSelect = '';

      // ng-dropdown settings
      vm.paxRangesSelected = [];
      vm.paxRangesSettings = {
        displayProp: 'name',
        showCheckAll: false,
        showUncheckAll: false,
        smartButtonMaxItems: 5,
        dynamicTitle: false,
        styleActive: true,
      };

      vm.paxRangesEvents = {
        onItemSelect: function (item) {
          selectPaxRange(item);
        },
        onItemDeselect: function (item) {
          if (vm.paxRangesSelected.length > 0) {
            paxRangeToSelect = vm.paxRangesSelected[0];
          } else {
            // Select at least one pax range
            paxRangeToSelect = item;
            vm.paxRangesSelected.push(item);
          }

          selectPaxRange(paxRangeToSelect);
        },
      };

      vm.translationText = {
        buttonDefaultText: 'Pax ranges',
      };

      if (vm.transportationPrices.length > 0) {
        // Edit and exists prices
        setPaxRangesSelected();
        paxRangeToSelect = paxRangeService.getLowestPaxRange(vm.paxRangesSelected);

        setItemOptions(vm.transportationPrices[0].updated_at);
      } else {
        // Create
        paxRangeToSelect = paxRangeService.getLowestPaxRange(vm.paxRanges);
        vm.paxRangesSelected.push(paxRangeToSelect);

        vm.lastUpdatedAt = false;

        vm.saveButtonLabel = 'SAVE_PRICES';
      }

      setPaxRangesData();
      selectPaxRange(paxRangeToSelect);
    };

    function setItemOptions(updateAt) {
      vm.editMode = true;

      vm.lastUpdatedAt = updateAt;
      vm.saveButtonLabel = 'UPDATE_PRICES';
    }

    // ----- PAX RANGES ----- //
    function selectPaxRange(paxRange) {
      vm.paxRangeSelected = paxRange;
    }

    // Sets the selected Pax Ranges options in the Pax range selector
    function setPaxRangesSelected() {
      vm.paxRangesSelected = [];

      vm.transportationPrices.forEach(function (transportationPrice) {
        vm.paxRanges.forEach(function (paxRange) {
          if (!checkIfPaxRangeExist(paxRange) && transportationPrice.pax_range_id === paxRange.id) {
            vm.paxRangesSelected.push(paxRange);
          }
        });
      });

      if (vm.paxRangesSelected.length === 0) {
        // fix
        vm.paxRangesSelected = [vm.paxRanges[0]];
      }
    }

    function checkIfPaxRangeExist(paxRange) {
      for (var i = 0; i < vm.paxRangesSelected.length; i++) {
        if (vm.paxRangesSelected[i] === paxRange) {
          return true;
        }
      }

      return false;
    }

    // Set all prices from the paxRange data, new or saved on the DB
    function setPaxRangesData() {
      vm.paxRangesData = [];

      vm.paxRanges.forEach(function (paxRange) {
        paxRange.transportation_schedules = [];

        // loop for the transportation schedules
        vm.transportation.transportation_schedules.forEach(function (transportationSchedule) {
          var schedule = setTransportationSchedule(transportationSchedule, paxRange);
          paxRange.transportation_schedules.push(schedule);
        });

        vm.paxRangesData.push(paxRange);
      });
    }

    // Gets the Transportation options schedule for the selected transportation and pax range
    function setTransportationSchedule(transportationSchedule, paxRange) {
      var transportationPriceId;
      var adultPrice = '',
        childPrice = 0,
        infantPrice = 0,
        seniorPrice = 0,
        servicePrice = 0;

      // Exist transportation prices
      if (vm.transportationPrices.length > 0) {
        for (var i = 0; i < vm.transportationPrices.length; i++) {
          var transportationPrice = vm.transportationPrices[i];

          if (
            transportationPrice.pax_range_id === paxRange.id &&
            transportationPrice.transportation_schedule_id === transportationSchedule.id
          ) {
            transportationPriceId = transportationPrice.id;

            adultPrice = transportationPrice.adult_price;
            childPrice = transportationPrice.child_price;
            infantPrice = transportationPrice.infant_price;
            seniorPrice = transportationPrice.senior_price;
            servicePrice = transportationPrice.service_price;
            break;
          }
        }
      }

      var schedule = {
        id: transportationSchedule.id,
        departure: transportationSchedule.departure,
        status: transportationSchedule.status,
        adult_price: adultPrice,
        child_price: childPrice,
        infant_price: infantPrice,
        senior_price: seniorPrice,
        service_price: servicePrice,
        transportationPriceId: null,
      };

      if (transportationPriceId) {
        schedule.transportationPriceId = transportationPriceId;
      }

      return schedule;
    }

    function saveTransportationPrices(isFormValid) {
      if (!isFormValid || vm.transportation.transportation_schedules.length === 0) {
        return;
      }

      var transportationPrices = [];

      for (var i = 0; i < vm.paxRangesSelected.length; i++) {
        var paxRangeSelected = vm.paxRangesSelected[i];

        for (var j = 0; j < vm.paxRangesData.length; j++) {
          var paxRangeData = vm.paxRangesData[j];

          if (paxRangeData.id === paxRangeSelected.id) {
            paxRangeData.transportation_schedules.forEach(function (transportationSchedule) {
              var price = {
                adult_price: transportationSchedule.adult_price || 0,
                child_price: transportationSchedule.child_price || 0,
                infant_price: transportationSchedule.infant_price || 0,
                senior_price: transportationSchedule.senior_price || 0,
                service_price: transportationSchedule.service_price || 0,

                transportation_schedule_id: transportationSchedule.id,
                pax_range_id: paxRangeSelected.id,
                id: null,
              };

              if (transportationSchedule.transportationPriceId) {
                price.id = transportationSchedule.transportationPriceId;
              }

              transportationPrices.push(price);
            });

            break; // check
          }
        }
      }

      var params = {
        transportation_prices: transportationPrices,
        price_list_id: vm.priceListSelected.id,
        season_id: vm.seasonSelected.id,
      };

      vm.sendingForm = true;
      TransportationPriceService.saveTransportationPrices(
        vm.transportation,
        params,
        vm.editMode
      ).then(function (data) {
        if (data) {
          vm.onTransportationPricesSaved();

          setItemOptions(data[0].updated_at);

          vm.transportationPrices = data;
          setPaxRangesData();
        }

        vm.sendingForm = false;
      });
    }

    function cancel() {
      vm.onTransportationPricesCanceled();
    }
  }
})();
